import { Building2, User } from "lucide-react";

export const SellerBadge = ({ type, className = "" }) => {
  const dealer = type === "rivenditore";
  return (
    <span
      data-testid={`seller-badge-${type}`}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${
        dealer ? "bg-emerald-800 text-emerald-50" : "bg-slate-600 text-slate-50"
      } ${className}`}
    >
      {dealer ? <Building2 size={12} /> : <User size={12} />}
      {dealer ? "Rivenditore" : "Privato"}
    </span>
  );
};

export const ModeBadge = ({ offers }) => (
  <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider ${
    offers ? "bg-amber-50 text-amber-700 border border-amber-200" : "bg-blue-50 text-blue-700 border border-blue-200"
  }`}>
    {offers ? "Accetta offerte" : "Prezzo fisso"}
  </span>
);
